<template>
  <div id="about_nav" class="about_nav">
    <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleTabClick" />
  </div>
</template>

<script>
import { SUBNAV } from '@/config/about';
import Tabs from 'vue-tabs-with-active-line';
export default {
  name: 'Aboutnav',
  components: {
    Tabs
  },
  data: function () {
    const tabs = SUBNAV.map(item => ({
      title: item.name,
      value: item.id
    }));
    return {
      tabs,
      currentTab: tabs[0].value
    };
  },
  mounted: function () {},
  methods: {
    /**
     * 处理tab点击事件
     * @param {string} value 被点击的tab值
     */
    handleTabClick(value) {
      // 更新当前tab
      this.currentTab = value;

      // 找到对应的索引
      const index = this.tabs.findIndex(tab => tab.value === value);

      // 向父组件发送tab切换事件
      this.$emit('tab-change', index);
    },

    /**
     * 更新当前tab（由父组件调用）
     * @param {number} index tab索引
     */
    updateCurrentTab(index) {
      const newTabValue = this.tabs[index].value;
      this.currentTab = newTabValue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
.about_nav {
  background: #fff
    url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/deb92e5d-2e4e-46b9-a1b0-ad7d1adad850.png')
    no-repeat center center;
  background-size: 100%;
  position: fixed;
  height: rem(210);
  width: 100%;
  top: rem(120);
  left: 0;
  text-align: center;
  z-index: 10;
}
::v-deep .tabs {
  position: relative;
  display: inline-flex;
  margin-top: rem(99);
  &::after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
  }

  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: rem(9);
    background-color: $mainActive;
    transition: all 0.3s ease;
  }

  &__item {
    margin-left: rem(72);
    padding: 0px;
    padding-bottom: rem(15);
    font-size: rem(42);
    line-height: rem(56);
    color: rgba(0, 0, 0, 0.55);
    text-decoration: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    @include disable-tap-highlight;
    &_active,
    &:hover {
      color: rgba(0, 0, 0, 1);
    }

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
